import { actions } from './actions'

const user = (state = { checked: false }, action) => {
  switch (action.type) {
    case actions.set:
      return Object.assign({}, action.user, { checked: true })
    default:
      return state
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/user/reducer.js